import { useState, useEffect } from 'react';
import { getMesConvocations, repondreEntrainement, repondreRencontre } from '../api';
import BandeauAnniversaires from './BandeauAnniversaires';
import ListeChronologique, { aujourdhuiIso } from './ListeChronologique';
import NotificationsCard from './NotificationsCard';
import PartageAnniversaire from './PartageAnniversaire';
import Voitures from './Voitures';

export default function MesConvocationsPage() {
  const [data, setData]   = useState({ entrainements: [], rencontres: [] });
  const [toast, setToast] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, []);
  async function load() {
    setLoading(true);
    try { setData(await getMesConvocations()); } finally { setLoading(false); }
  }
  function showToast(msg, type='success') { setToast({msg,type}); setTimeout(()=>setToast(null),2500); }

  async function repondre(type, id, present, extra = {}) {
    try {
      if (type === 'ent') await repondreEntrainement(id, { present });
      else                await repondreRencontre(id, { present, ...extra });
      showToast(present ? '✅ Présence confirmée' : 'Absence enregistrée');
      load();
    } catch(err) { showToast(err.message, 'error'); }
  }

  if (loading) return <div style={{ padding:40, textAlign:'center', color:'#8b949e' }}>Chargement…</div>;

  const total = data.entrainements.length + data.rencontres.length;
  const enAttente = [...data.entrainements, ...data.rencontres].filter(x => !x.repondu && (x.date || '') >= aujourdhuiIso()).length;   // jamais les événements passés

  const Item = ({ x, type }) => (
    <div className="card" style={{ marginBottom:10 }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:10, flexWrap:'wrap' }}>
        <div>
          <div className="card-meta">{x.date}{x.dom_ext && ` · ${x.dom_ext}`}{type !== 'renc' && x.heure ? ` · ${x.heure}` : ''}</div>
          <div className="card-title">{type === 'renc' ? `vs ${x.adversaire}` : (x.theme || 'Entraînement')}</div>
          {type === 'renc' && (x.heure_rdv || x.heure) && (
            <div style={{ display:'flex', gap:10, marginTop:4, flexWrap:'wrap', fontSize:11.5 }}>
              {x.heure_rdv && <span style={{ color:'#eab308', fontWeight:700 }}>⏰ RDV {x.heure_rdv}</span>}
              {x.heure && <span style={{ color:'#8b949e' }}>🤾 Match {x.heure}</span>}
            </div>
          )}
          {x.lieu && <div className="card-meta" style={{ marginTop:2 }}>📍 {x.lieu}</div>}
        </div>
        {x.repondu ? (
          <span className={`badge badge-${x.present ? 'V' : 'N'}`}>
            {x.present ? 'Présent' : 'Absent'}
          </span>
        ) : (
          <span style={{ fontSize:10, color:'#8b949e', border:'1px solid rgba(255,255,255,0.08)', borderRadius:6, padding:'3px 8px' }}>
            À confirmer
          </span>
        )}
      </div>
      <div style={{ display:'flex', gap:8, marginTop:12 }}>
        <button
          onClick={() => repondre(type === 'renc' ? 'renc' : 'ent', x.id, true)}
          style={{
            flex:1, padding:'10px', borderRadius:8, cursor:'pointer',
            border: `1px solid ${x.repondu && x.present ? '#22c55e' : 'rgba(255,255,255,0.08)'}`,
            background: x.repondu && x.present ? 'rgba(34,197,94,0.15)' : 'transparent',
            color: x.repondu && x.present ? '#22c55e' : '#8b949e',
            fontSize:13, fontWeight:700, fontFamily:'Barlow Condensed',
            letterSpacing:1, textTransform:'uppercase'
          }}>
          ✓ Je serai là
        </button>
        <button
          onClick={() => repondre(type === 'renc' ? 'renc' : 'ent', x.id, false)}
          style={{
            flex:1, padding:'10px', borderRadius:8, cursor:'pointer',
            border: `1px solid ${x.repondu && !x.present ? '#eab308' : 'rgba(255,255,255,0.08)'}`,
            background: x.repondu && !x.present ? 'rgba(234,179,8,0.15)' : 'transparent',
            color: x.repondu && !x.present ? '#eab308' : '#8b949e',
            fontSize:13, fontWeight:700, fontFamily:'Barlow Condensed',
            letterSpacing:1, textTransform:'uppercase'
          }}>
          ✕ Absent
        </button>
      </div>

      {/* Covoiturage — matchs à l'extérieur, joueur présent */}
      {type === 'renc' && x.dom_ext === 'Extérieur' && x.repondu && x.present && (
        <div style={{ marginTop:12, paddingTop:12, borderTop:'1px solid rgba(255,255,255,0.07)' }}>
          <div style={{ fontSize:10, color:'#8b949e', letterSpacing:1.5, textTransform:'uppercase',
            fontWeight:600, marginBottom:8 }}>
            🚗 Déplacement
          </div>

          <div style={{ display:'flex', gap:8, marginBottom:10 }}>
            <button onClick={() => repondre('renc', x.id, true, { depart_auneau:true, places:x.places||0 })}
              style={{ flex:1, padding:'9px', borderRadius:8, cursor:'pointer', fontSize:12, fontWeight:600,
                border:`1px solid ${x.depart_auneau ? '#3b82f6' : 'rgba(255,255,255,0.08)'}`,
                background: x.depart_auneau ? 'rgba(59,130,246,0.14)' : 'transparent',
                color: x.depart_auneau ? '#3b82f6' : '#8b949e' }}>
              Je pars du club
            </button>
            <button onClick={() => repondre('renc', x.id, true, { depart_auneau:false, places:0 })}
              style={{ flex:1, padding:'9px', borderRadius:8, cursor:'pointer', fontSize:12, fontWeight:600,
                border:`1px solid ${!x.depart_auneau ? '#3b82f6' : 'rgba(255,255,255,0.08)'}`,
                background: !x.depart_auneau ? 'rgba(59,130,246,0.14)' : 'transparent',
                color: !x.depart_auneau ? '#3b82f6' : '#8b949e' }}>
              Direct au match
            </button>
          </div>

          {x.depart_auneau ? (
            <div>
              <div style={{ fontSize:11.5, color:'#8b949e', marginBottom:7 }}>
                Je peux emmener combien de coéquipiers ?
              </div>
              <div style={{ display:'flex', gap:6 }}>
                {[0,1,2,3,4].map(n => (
                  <button key={n}
                    onClick={() => repondre('renc', x.id, true, { depart_auneau:true, places:n })}
                    style={{ flex:1, padding:'9px 0', borderRadius:8, cursor:'pointer',
                      fontSize:14, fontWeight:700, fontFamily:'Barlow Condensed',
                      border:`1px solid ${(x.places||0) === n ? '#22c55e' : 'rgba(255,255,255,0.08)'}`,
                      background: (x.places||0) === n ? 'rgba(34,197,94,0.14)' : 'transparent',
                      color: (x.places||0) === n ? '#22c55e' : '#8b949e' }}>
                    {n === 0 ? '🚶' : n}
                  </button>
                ))}
              </div>
              <div style={{ fontSize:10.5, color:'#6b7280', marginTop:6 }}>
                {(x.places||0) === 0 ? "Pas de voiture — choisis une voiture ci-dessous" :
                 `J'ai ${x.places} place${x.places>1?'s':''} disponible${x.places>1?'s':''}`}
              </div>
              <Voitures rencontreId={x.id} onToast={showToast} cle={`${x.present}-${x.depart_auneau}-${x.places}`} />
            </div>
          ) : (
            <div style={{ fontSize:11.5, color:'#8b949e' }}>
              Tu rejoins directement le gymnase.
            </div>
          )}
        </div>
      )}
    </div>
  );

  return (
    <>
      <div className="page-header">
        <div className="eyebrow">Mon espace</div>
        <h1>📩 Mes convocations</h1>
        {enAttente > 0 && (
          <div className="sub" style={{ color:'var(--accent)', fontWeight:700 }}>
            {enAttente} réponse{enAttente>1?'s':''} en attente
          </div>
        )}
      </div>

      <div className="section">
        <BandeauAnniversaires />
        <NotificationsCard onToast={showToast} />
        <PartageAnniversaire onToast={showToast} />

        {total === 0 && (
          <div className="card" style={{ textAlign:'center', color:'#8b949e', padding:'30px 16px' }}>
            Aucune convocation pour le moment.
          </div>
        )}

        {data.rencontres.length > 0 && (
          <>
            <div className="section-title">⚽ Rencontres</div>
            <ListeChronologique elements={data.rencontres} rendre={r => <Item key={`r${r.id}`} x={r} type="renc" />} />
          </>
        )}

        {data.entrainements.length > 0 && (
          <>
            <div className="section-title" style={{ marginTop:20 }}>🏃 Entraînements</div>
            <ListeChronologique elements={data.entrainements} rendre={e => <Item key={`e${e.id}`} x={e} type="ent" />} />
          </>
        )}
      </div>
      {toast && <div className={`toast ${toast.type}`}>{toast.msg}</div>}
    </>
  );
}
